<div class="modal-header">
  <h4 class="modal-title" id="modal-basic-title" i18n="@@itemHotelsFacilities" id="modal-header">
    Facilities
  </h4>
  <button type="button" class="close" aria-label="Close" (click)="activeModal.close()">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body">
  <ul
    class="hotel-amenities-list flex-row-container flex-row-container--tb-margin flex-row-container--wrap"
    aria-label="Hotel amenities"
    i18n-aria-label="@@hotelAmenitiesListLabel"
  >
    @for (tag of hotel?.sortedTags; track tag) {
      <li class="hotel-amenities-list__item">
        <section class="container">
          @if (tag.name === AmenitiesSearchHandler.ECO_FRIENDLY && faLeaf) {
            <div class="eco-friendly-icon" (mouseleave)="tt1.close()">
              <fa-icon
                triggers="manual"
                #tt1="ngbTooltip"
                (mouseenter)="tt1.open()"
                ngbTooltip="{{ tag.display }}"
                [attr.aria-label]="tag.display | translate"
                (focus)="tt1.open()"
                (blur)="tt1.close()"
                tabindex="0"
                [icon]="faLeaf"
              >
              </fa-icon>
            </div>
          } @else {
            <section (mouseleave)="tt.close()" class="container">
              <img
                class="preferred-container__icon list"
                src="{{ tag.icon }}"
                height="24"
                width="24"
                triggers="manual"
                #tt="ngbTooltip"
                (mouseenter)="tt.open()"
                ngbTooltip="{{ tag.display }}"
                (focus)="tt.open()"
                (blur)="tt.close()"
                tabindex="0"
                [alt]="tag.display | translate"
              />
            </section>
          }
        </section>
      </li>
    }
  </ul>
</div>
<div class="modal-footer">
  <button
    type="button"
    class="btn btn-outline-dark"
    (click)="activeModal.close()"
    i18n="@@itemHotelsClose"
  >
    close
  </button>
</div>
